module.exports = __webpack_public_path__ + "static/media/hall-AE.3c1c3ee0.svg";